// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"8770bc76","131":"284bfa9c","381":"284bfa9c","504":"1299eace","776":"8c7663f6","989":"284bfa9c"}[chunkId] + ".chunk.css";
};